export default __webpack_public_path__ + "static/7-8172a305eaec146d0014f70cab0558cc.jpg";